import { render, staticRenderFns } from "./vi.vue?vue&type=template&id=06e37dfb&"
import script from "./vi.vue?vue&type=script&lang=js&"
export * from "./vi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports